import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import ProtectedRoute from './ProtectedRoute';
import Login from './Components/pages/LoginPage';
import AdminPage from './Components/pages/AdminPage';
import AICalls from './Components/tabs/Admin/AICalls';
import DashboardPage from './Components/pages/DashboardPage';
import EscalationsPage from './Components/pages/EscalationsPage';
import PageHeader from './Components/reusable-components/PageHeader';
import ForgotPasswordPage from './Components/pages/ForgotPasswordPage';
// import PagesAutoLogout from './Components/reusable-components/PagesAutoLogOut';

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const loginTimeStr = localStorage.getItem('loginTimestamp');
    const loginTime = loginTimeStr ? parseInt(loginTimeStr, 10) : null;
    const now = Date.now();
    const withinOneHour = loginTime !== null && !isNaN(loginTime) && (now - loginTime) < 60 * 60 * 1000;
    const auth = localStorage.getItem('isAuthenticated') === 'true';
    return auth && withinOneHour;
  });

  const handleLogout = () => {
    setIsAuthenticated(false);
    const keysToKeep = ['rememberedEmail', 'rememberedPassword'];
    Object.keys(localStorage).forEach((key) => {
      if (!keysToKeep.includes(key)) {
        localStorage.removeItem(key);
      }
    });
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      const loginTimeStr = localStorage.getItem('loginTimestamp');
      const loginTime = loginTimeStr ? parseInt(loginTimeStr, 10) : null;
      const now = Date.now();
      if (isAuthenticated && loginTime !== null && !isNaN(loginTime) && now - loginTime > 60 * 60 * 1000) {
        handleLogout();
      }
    }, 30000); // check every 30 seconds

    return () => clearInterval(intervalId);
  }, [isAuthenticated]);

  return (
    <Router>
      <div className="flex flex-col min-h-screen overflow-hidden bg-blue-50">
        {window.location.pathname.toLowerCase() !== "/forgotpassword" && isAuthenticated && (
          <PageHeader onLogout={handleLogout} />
        )}
        {/* In future if needed inactivity of user on pages and to show stay logged in */}
        {/* {isAuthenticated && <PagesAutoLogout onLogout={handleLogout} />} */}
        <Routes>
          {['/', '/login'].map(path => (
            <Route
              key={path}
              path={path}
              element={
                isAuthenticated
                  ? <Navigate to="/dashboard" replace />
                  : <Login setIsAuthenticated={setIsAuthenticated} />
              }
            />
          ))}
          <Route path="/login" element={
            isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login setIsAuthenticated={setIsAuthenticated} />
          } />
          <Route path="/forgotpassword" element={<ForgotPasswordPage />} />
          <Route path="/dashboard" element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <DashboardPage />
            </ProtectedRoute>
          } />
          <Route path="/escalations" element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <EscalationsPage />
            </ProtectedRoute>
          } />
          <Route path="/admin" element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <AdminPage />
            </ProtectedRoute>
          } />
          <Route path="/admin/calls" element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <AICalls />
            </ProtectedRoute>
          } />
          <Route path="*" element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <div className="p-6 text-center bg-white rounded-lg shadow">
                <h2 className="text-xl font-medium text-gray-800">Page not found</h2>
              </div>
            </ProtectedRoute>
          } />
        </Routes>
      </div>
    </Router>
  );
}